import { Check, Copy } from 'lucide-react';
import { useState } from 'react';

const SNIPPET = `<script
  src="https://api.yourdomain.com/api/chat/widget.js"
  data-chat-key="wk_live_your_widget_key"
  data-theme="light"
  data-position="bottom-right"
  async
></script>`;

/**
 * Copy-pasteable embed block showing the real widget loader snippet
 * (matches the attributes parsed by apps/widget iife-entry: data-chat-key,
 * data-theme, data-position). One script tag — that's the whole install.
 */
export function EmbedSnippet(): JSX.Element {
  const [copied, setCopied] = useState(false);

  const copy = (): void => {
    void navigator.clipboard?.writeText(SNIPPET).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-border bg-[#0d1117] shadow-lg">
      <div className="flex items-center justify-between border-b border-white/10 px-4 py-2.5">
        <span className="text-xs font-medium text-white/60">
          Paste before &lt;/body&gt;
        </span>
        <button
          type="button"
          onClick={copy}
          className="inline-flex items-center gap-1.5 rounded-md bg-white/10 px-2.5 py-1 text-xs font-medium text-white transition-colors hover:bg-white/20"
          aria-label="Copy embed snippet"
        >
          {copied ? (
            <>
              <Check className="h-3.5 w-3.5 text-emerald-400" />
              Copied
            </>
          ) : (
            <>
              <Copy className="h-3.5 w-3.5" />
              Copy
            </>
          )}
        </button>
      </div>
      <pre className="overflow-x-auto px-4 py-4 text-xs leading-relaxed text-emerald-300">
        <code>{SNIPPET}</code>
      </pre>
    </div>
  );
}
